module.exports = __webpack_public_path__ + "static/back_picture_orange-d89343df02ff744a19c7011898978034.svg";